import { FIELDS } from 'modules/cm/fields/types';
import { dateValidation, todayAndFutureDateValidation } from 'utils/date';
import {
  emailValidation,
  humanAnyNameValidation,
  nullableNumber,
  nullableString,
  postcodeValidation,
  telephoneValidation,
} from 'utils/form/validation';
import * as yup from 'yup';
import { Admin, CaseDetails, Solicitor } from '../../CaseDetailsPage.types';

const messages = {
  required: 'This field is required',
};

const solicitorShape = {
  [FIELDS.SOLICITOR_NAME]: humanAnyNameValidation(),
  [FIELDS.SOLICITOR_CONTACT_NUMBER]: telephoneValidation().nullable(),
  [FIELDS.SOLICITOR_EMAIL]: emailValidation(),
  [FIELDS.SOLICITOR_FLAT_NUMBER]: nullableString(),
  [FIELDS.SOLICITOR_BUILDING_NUMBER]: nullableString(),
  [FIELDS.SOLICITOR_BUILDING_NAME]: nullableString(),
  [FIELDS.SOLICITOR_STREET]: nullableString(),
  [FIELDS.SOLICITOR_ADDRESS_CITY]: nullableString(),
  [FIELDS.SOLICITOR_ADDRESS_POSTCODE]: postcodeValidation().nullable(),
};

const adminShape = {
  [FIELDS.ADMIN_OFFER_DATE]: dateValidation().nullable(),
  [FIELDS.ADMIN_COT_REC_DATE]: dateValidation().nullable(),
  [FIELDS.ADMIN_FUNDS_REQ_DATE]: dateValidation().nullable(),
  [FIELDS.ADMIN_EXPECTED_COMPLETION_DATE]: todayAndFutureDateValidation().nullable(),
  [FIELDS.ADMIN_COMPLETION_DATE]: dateValidation().nullable(),
  [FIELDS.ADMIN_PEPPER_UPLOAD_DATE]: dateValidation().nullable(),
  [FIELDS.ADMIN_PEPPER_ACCOUNT_ID]: nullableString(),
  [FIELDS.ADMIN_ORIGINATOR_ID]: nullableString(),
  [FIELDS.ADMIN_DECLINE_DATE]: dateValidation().nullable(),
  [FIELDS.ADMIN_SWAP_COST]: nullableNumber(),
  [FIELDS.ADMIN_EXPECTED_MATURITY]: nullableNumber(),
};

export default yup.object().shape<CaseDetails['case']['contact']>({
  [FIELDS.ADVISER_NAME]: humanAnyNameValidation()
    .nullable()
    .required(messages.required),
  [FIELDS.ADVISER_PHONE]: telephoneValidation()
    .nullable()
    .required(messages.required),
  [FIELDS.ADVISER_EMAIL]: emailValidation()
    .nullable()
    .required(messages.required),
  [FIELDS.FIRM_FCA_NUMBER]: nullableString().required(messages.required),
  [FIELDS.FIRM_NAME]: nullableString().required(messages.required),
  [FIELDS.FIRM_ADDRESS]: nullableString().required(messages.required),
  [FIELDS.NETWORK_FCA_NUMBER]: nullableString().required(messages.required),
  [FIELDS.STANDARD_COMMISSION_TERMS]: nullableString(),
  [FIELDS.ENHANCED_COMMISSION_TERMS]: nullableString(),
  [FIELDS.ONGOING_COMMISSION_TERMS_UPFRONT_FEE]: nullableString(),
  [FIELDS.ONGOING_COMMISSION_TERMS_ONGOING_FEE]: nullableString(),
  [FIELDS.ADVISER_FEE]: nullableNumber().required(messages.required),
  [FIELDS.ADVISER_FEE_LAST_PAYMENT_MOMENT]: nullableString(),
  [FIELDS.PACKAGER_FEE]: nullableNumber().required(messages.required),
  [FIELDS.PACKAGER_FEE_LAST_PAYMENT_MOMENT]: nullableString(),
  [FIELDS.SOLICITOR_PREFIX]: yup.object().shape<Solicitor>(solicitorShape),
  [FIELDS.ADMIN_PREFIX]: yup.object().shape<Admin>(adminShape),
});
